import React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import Routes from 'routes';
import { useAppContext } from 'contexts/AppContext';
import { useRouteGuards } from 'globals/hooks/useRouteGuards';
import FsScreenOfDeathBox from 'ui-elements/boxes/FsScreenOfDeathBox';
import FsUserPanelLayout from 'ui-elements/layouts/FsUserPanelLayout';
import { useRole } from 'globals/hooks/useRole';
import { UserRole } from 'globals/types';
import WelcomeDashboard from './Pages/WelcomeDashboard';
import Report from './Pages/Report';
import Dashboard from './Pages/Dashboard';
import Reports from './Pages/Reports';
import Invitations from './Pages/Invitations';
import Settings from './Pages/Settings';
import Developers from './Pages/Developers/Developers';
import ProfileSettings from './Pages/ProfileSettings';
import Leaderboard from './Pages/Leaderboard';
import Billings from './Pages/Billings';
import { BlockedWrapperBox, PagesWrapperBox } from './UserPanel.style-elements';
import InviteCustomer from './Pages/InviteCustomer';

const UserPanel: React.FC = () => {
  const { isBlocked } = useAppContext();
  const isBillingRoute = useRouteGuards(Routes.BILLINGS);
  const isDevelopersRoute = useRouteGuards(Routes.DEVELOPERS);
  const isLeaderboardRoute = useRouteGuards(Routes.LEADERBOARD);
  const isSettingsRoute = useRouteGuards(Routes.LEADERBOARD);
  const isAccountant = useRole(UserRole.ACCOUNTANT);

  return (
    <FsUserPanelLayout>
      {isBlocked ? (
        <BlockedWrapperBox>
          <Switch>
            {isBillingRoute && (
              <Route path={Routes.BILLINGS} component={Billings} />
            )}
            <Route exact path={Routes.ROOT} component={FsScreenOfDeathBox} />
            <Redirect to={Routes.ROOT} />
          </Switch>
        </BlockedWrapperBox>
      ) : (
        <PagesWrapperBox>
          <Switch>
            <Route path={Routes.ROOT} exact component={WelcomeDashboard} />
            <Route path={Routes.PROFILE_SETTINGS} component={ProfileSettings} />
            {!isAccountant && (
              <Route path={Routes.DASHBOARD} exact component={Dashboard} />
            )}
            {!isAccountant && (
              <Route path={Routes.REPORTS} component={Reports} />
            )}
            {!isAccountant && <Route path={Routes.REPORT} component={Report} />}
            {!isAccountant && (
              <Route path={Routes.INVITATIONS} component={Invitations} />
            )}
            {!isAccountant && (
              <Route path={Routes.INVITE_CUSTOMER} component={InviteCustomer} />
            )}
            {isSettingsRoute && (
              <Route path={Routes.SETTINGS} component={Settings} />
            )}
            {isLeaderboardRoute && (
              <Route path={Routes.LEADERBOARD} component={Leaderboard} />
            )}
            {isDevelopersRoute && (
              <Route path={Routes.DEVELOPERS} component={Developers} />
            )}
            {isBillingRoute && (
              <Route path={Routes.BILLINGS} component={Billings} />
            )}
            {/* REDIRECT | IF VERIFIED & PATH: Login - redirect to ROOT path  */}
            <Route
              path={Routes.LOGIN}
              render={() => <Redirect to={Routes.ROOT} />}
            />
            {/* REDIRECT | IF NO PATH WAS MATCHED - redirect to ROOT path  */}
            <Redirect to={Routes.ROOT} />
          </Switch>
        </PagesWrapperBox>
      )}
    </FsUserPanelLayout>
  );
};

export default UserPanel;
